(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ELED-collection-filter-buttons"] && !Shopify.designMode) return;
  try {
    
  //When a .collection-filters filter is clicked, deselect any other active filters, then click the corresponding filter in #facet-filters
  document.querySelectorAll('.collection-filters .filter').forEach(function (el) {
    el.addEventListener('click', function () {
      var name = el.dataset.filterName;
      var value = el.dataset.filterValue;
      var input = document.querySelector('#facet-filters input[name=\'' + name + '\'][value=\'' + value + '\']');
      if (!input) return;

      var activeEl = document.querySelector('.collection-filters .filter.filter-active');

      //Deselect other active filters if a new input is selected and another filter is active
      if (!input.checked && activeEl) {
        //Don't check if the user is deselecting the active element
        if (activeEl === el) return;

        var otherInput = document.querySelector('#facet-filters input[name=\'' + activeEl.dataset.filterName + '\'][value=\'' + activeEl.dataset.filterValue + '\']');
        if (otherInput && otherInput.checked) otherInput.click();
      }

      //If the input is currently disabled, enable it so that it can be clicked
      if (input.disabled) input.disabled = false;
      input.click();
    });
  });

  //Toggle .filter-active on the matching .collection-filters filter when a filter in #facet-filters is (un)checked
  function onFacetFilterClick(e) {
    var el = e.currentTarget;
    var name = el.getAttribute('name');
    var value = el.getAttribute('value');

    var customElem = document.querySelector('.collection-filters .filter[data-filter-name=\'' + name + '\'][data-filter-value=\'' + value + '\']');
    if (!customElem) return;
    customElem.classList.toggle('filter-active', el.checked);
  }

  //Add the click event listeners to the #facet-filters checkboxes, toggle the .filter-active class
  function bindFacetFilterCheckboxes() {
    document.querySelectorAll('#facet-filters input.checkbox').forEach(function (el) {
      //Add a check to not add multiple event listeners
      if (el.dataset.filterButtonBound) return;
      el.dataset.filterButtonBound = 'true';

      el.addEventListener('click', onFacetFilterClick);

      var customElem = document.querySelector('.collection-filters .filter[data-filter-name=\'' + el.getAttribute('name') + '\'][data-filter-value=\'' + el.getAttribute('value') + '\']');
      if (customElem) customElem.classList.toggle('filter-active', el.checked);
    });
  }

  bindFacetFilterCheckboxes();

  //When a filter is selected, add back the event listeners
  var facetFiltersEl = document.querySelector('#facet-filters');
  if (facetFiltersEl) {
    new MutationObserver(bindFacetFilterCheckboxes).observe(facetFiltersEl, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
